import userConstants from '../Constants/userConstants'

export const changeMROpenCount = () => {
  return {
    type: userConstants.CHANGE_MR_OPEN_COUNT,
  }
}
